/* istanbul ignore file */
import React, { useEffect, useState } from "react";

import { Link as RouterLink, useParams } from "react-router-dom";

import { Box, Typography } from "@material-ui/core";
import LinearProgress from "@mui/material/LinearProgress";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Tooltip from "@mui/material/Tooltip";

import classes from "../TableContainer/TableContainer.module.css";
import citationClasses from "./Citation.module.css";
// import theme from "../../themes/theme.module.css";
import { getCitations } from "../../utils/HttpClientProvider";
import JDPTooltip, { ICON_NONE } from "../UI/Tooltip/Tooltip";

const Citation = () => {
  const [data, setData] = useState();
  const { id } = useParams();
  const [copyText, setCopyText] = useState();

  const copyTextToClipboard = () => {
    if ("clipboard" in navigator) {
      // do not make another copy in 1s
      setTimeout(() => {
        setCopyText(null);
      }, 1000);

      return navigator.clipboard.writeText(copyText.text);
    }
  };

  useEffect(() => {
    const promise = getCitations(id);
    promise.then((resp) => {
      setData(resp);
    });
  }, [id]);

  useEffect(() => {
    if (copyText) {
      copyTextToClipboard();
    }
  }, [copyText]);

  const toIndex = (bKey, idx) => `${Boolean(bKey)}_${idx}`;

  const copyIcon = (text, primary, index) => {
    return (
      <FileCopyIcon
        className={citationClasses.copyIcon}
        onClick={() => {
          if (!copyText) {
            setCopyText({ index: toIndex(primary, index), text });
          }
        }}
      />
    );
  };

  const createCitation = (d, primary, index) => {
    const {
      authors,
      title: oriTitle,
      publication_abbrev: journal,
      date,
      volume,
      issue,
      first_page,
      last_page,
      pmid: PMID,
      doi,
      pmc: PMCID,
    } = d;

    // author name in LAST_NAME, FM format; F=FIRST_NAME[0], M=MIDDLE_NAME[0]

    const authorList = authors.map((a) => {
      const fm = a.first_name.split(" ").map((fn) => fn[0]);
      return `${a.last_name} ${fm.join("")}`;
    });

    const title =
      oriTitle?.length > 0 && oriTitle.endsWith(".")
        ? oriTitle.substring(0, oriTitle.length - 1)
        : oriTitle;
    const link = PMID ? (
      <Link
        component={RouterLink}
        target="_blank"
        to={`//pubmed.ncbi.nlm.nih.gov/${PMID}/`}
      >
        {title}
      </Link>
    ) : (
      title
    );

    const journalParams = [];
    if (journal) {
      journalParams.push(journal);
    }
    if (date) {
      journalParams.push(`(${date})`);
    }
    const jmeta = [
      {
        issue,
        volume,
      },
      {
        PMID,
        doi,
        PMCID,
      },
    ];

    jmeta.forEach((blk, idx) => {
      if (idx === 1) {
        if (first_page && last_page) {
          journalParams.push(`pages: ${first_page}-${last_page}`);
        } else if (first_page) {
          journalParams.push(`page: ${first_page}`);
        }
      }
      Object.keys(blk).forEach((j) => {
        if (blk[j]) {
          journalParams.push(`${j}: ${blk[j]}`);
        }
      });
    });

    const text2 = journalParams.join(", ");

    const pos = toIndex(primary, index);
    const icon = copyIcon(
      `${authorList.join(", ")}, ${title}, ${text2}`,
      primary,
      index
    );

    return (
      <Box>
        <Typography className={citationClasses.citation}>
          {authorList.join(", ")}, {link}, {text2}
        </Typography>
        <Grid container justifyContent="flex-end">
          {primary && (
            <Typography className={citationClasses.iconLabel}>
              Primary Publication
            </Typography>
          )}

          {copyText?.index === pos ? (
            <Tooltip
              data-testid="avatar-tool-tip"
              PopperProps={{
                disablePortal: true,
              }}
              open={copyText?.index === pos}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={
                <span style={{ fontSize: 16 }}>
                  Citation copied into clipboard
                </span>
              }
              placement="top"
            >
              {icon}
            </Tooltip>
          ) : (
            <JDPTooltip title="Copy this Citation" iconType={ICON_NONE}>
              {icon}
            </JDPTooltip>
          )}
          {/* {copyText?.index === pos ? <span>ICON</span> : <span>NONE</span>} */}
        </Grid>
      </Box>
    );
  };

  return (
    <>
      <Box style={{ margin: "0px 120px", minWidth: "800px" }}>
        <Box className={classes.titleBox}>
          <Typography
            style={{
              fontFamily: "Merriweather",
              fontSize: 40,
              fontWeight: "bold",
            }}
          >
            Publications that mention this dataset:{" "}
            {data ? data.name : <LinearProgress />}
          </Typography>
        </Box>
        {data && (
          <Box className={citationClasses.topBox}>
            {data.citations?.primary && (
              <Box className={citationClasses.primaryCitationBox}>
                {data.citations.primary.map((d, idx) => {
                  const key = `citation-primary-${idx}`;
                  return (
                    <Box key={key} style={{ paddingBottom: 20 }}>
                      {createCitation(d, true, idx)}
                    </Box>
                  );
                })}
              </Box>
            )}
            {data.citations?.other && (
              <Box className={citationClasses.citationBox}>
                {data.citations.other &&
                  data.citations.other.map((d, idx) => {
                    const key = `citation-primary-${idx}`;
                    return (
                      <Box key={key} style={{ paddingBottom: 20 }}>
                        {createCitation(d, false, idx)}
                      </Box>
                    );
                  })}
              </Box>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};

export default Citation;
